<div [ngClass]="resourceVmUpNext ? 'background' : ''">
  <div class="back-btn" (click)="upNextClose()"></div>
  <!-- Up next carousel -->
  <div class="play-next focusable-container horizontal-focusable-container" data-blocked *ngIf="resourceVmUpNext">
    <div tabindex="0" class="play-next__card focusable-element image-parent" (click)="upNextClick()">
      <app-tag [isBlocked]="resourceVmUpNext.isPremium" position="top-right"></app-tag>
      <app-tag [text]="resourceVmUpNext.tags && resourceVmUpNext.tags.length > 0 ? resourceVmUpNext.tags[0] : undefined"></app-tag>
      <img class="default--16x9" loading="lazy" src="{{ resourceVmUpNext.image }}" onerror="this.src=''" alt="" />
      <div class="play-next__card__play-button"></div>
    </div>

    <div class="play-next__content">
      <h5 class="play-next__content__time-left">{{ 'player.upNextIn' | translate }} {{ timeLeft }} sec</h5>
      <h5 class="play-next__content__title"> <span *ngIf="resourceVmUpNext.episodeNumber">S{{ resourceVmUpNext.seasonNumber}}E{{resourceVmUpNext.episodeNumber}}:</span> {{ resourceVmUpNext.title }}</h5>
      <p  class="play-next__content__description" *ngIf="resourceVmUpNext.isSeries; else ratings"> {{ resourceVmUpNext.shortDescription }}</p>
      <ng-template #ratings>
      <p  class="play-next__content__description" *ngIf="resourceVmUpNext?.ratings && resourceVmUpNext.ratings.length > 0">{{ resourceVmUpNext.ratings[0].v }}</p>
      </ng-template>
    </div>

    <div tabindex="0" class="play-next__back back-btn focusable-element" (click)="upNextClose()">
      {{ 'player.cancel' | translate }}
    </div>
  </div>
</div>
